import { getAxios } from './apiUtils';

export const login = async credentials => {
  try {
    const response = await getAxios().post('/api/auth/login', credentials);
    if (response.status === 400 || response.status === 500) {
      throw new Error('Invalid username or password');
    }
    return response.data.access_token;
  } catch (error) {
    throw new Error('Invalid username or password');
  }
};
export const loginOauth = async accessToken => {
  try {
    const response = await getAxios().get('/api/auth/oauth/' + accessToken);
    if (response.status === 400 || response.status === 500) {
      throw new Error('Invalid username or password');
    }
    return response.data.access_token;
  } catch (error) {
    throw new Error('Invalid username or password');
  }
};
export const updatePassword = async credentials => {
  try {
    return await getAxios().post('/api/auth/set-password', credentials);
  } catch (error) {
    throw new Error('Invalid password reset attempt. This page may have expired.  Try resetting your password again. ');
  }
};
export const resetPassword = async email => {
  try {
    return await getAxios().post('/api/auth/reset-password', email);
  } catch (error) {
    throw new Error('An unknown error occurred');
  }
};
export const getRebelMouseRoles = async email => {
  return await getAxios()
    .get('/api/user-role/rebelmouse/' + email)
    .then(res => res.data);
};
export const getUserById = async id => {
  return await getAxios()
    .get('/api/user/' + id)
    .then(res => res.data);
};
